import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getReportData, getReportHeader } from '../../../services'

const initialState = {
  headers: [],
  reportData: [],
  statusHeaders: '',
  statusData: '',
}

export const getReportHeadersThunk = createAsyncThunk('report/headers', async token => {
  const response = await getReportHeader(token)
  return response
})

export const getReportDataThunk = createAsyncThunk('report/data', async token => {
  const response = await getReportData(token)
  return response
})

export const reportSlice = createSlice({
  name: 'reportSlice',
  initialState,
  reducers: {
    setStatusData: (state, action) => {
      state.statusData = action.payload
    },
    setStatusHeaders: (state, action) => {
      state.statusHeaders = action.payload
    },
    setReportData: (state, action) => {
      state.reportData = action.payload
    },
    setHeaders: (state, action) => {
      state.headers = action.payload
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getReportHeadersThunk.pending, state => {
        state.statusHeaders = 'loading'
      })
      .addCase(getReportHeadersThunk.fulfilled, (state, action) => {
        state.statusHeaders = 'succeeded'
        state.headers = action.payload
      })
      .addCase(getReportHeadersThunk.rejected, state => {
        state.statusHeaders = 'failed'
      })

    builder
      .addCase(getReportDataThunk.pending, state => {
        state.statusData = 'loading'
      })
      .addCase(getReportDataThunk.fulfilled, (state, action) => {
        state.statusData = 'succeeded'
        state.reportData = action.payload
      })
      .addCase(getReportDataThunk.rejected, state => {
        state.statusData = 'failed'
      })
  },
})

export const { setStatusData, setStatusHeaders, setReportData, setHeaders } =
  reportSlice.actions
export default reportSlice.reducer
